// Scroll reveal, as on the homepage: each .reveal fades up as it enters view and its [data-stagger]
// children follow in sequence (--i sets the order). Content added later is revealed with observeReveal().
let io = null;
let enabled = false;

const reduced = () => !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);

export function initReveal() {
  const root = document.documentElement;
  if (window.__noticedRevealFallback || reduced() || !("IntersectionObserver" in window)) {
    root.classList.remove("js-reveal");
    enabled = false;
    return;
  }
  root.classList.add("js-reveal");
  enabled = true;
  io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        // Tall elements (long lists) may never be 12% visible, so a quarter screen of them is enough too.
        if (e.isIntersecting && (e.intersectionRatio >= 0.12 || e.intersectionRect.height >= window.innerHeight * 0.25)) {
          e.target.classList.add("revealed");
          io.unobserve(e.target);
        }
      }
    },
    { threshold: [0, 0.12, 0.25], rootMargin: "0px 0px -8% 0px" },
  );
  observeReveal(document);
}

export function observeReveal(scope = document) {
  const els = [];
  if (scope.matches && scope.matches(".reveal")) els.push(scope);
  els.push(...scope.querySelectorAll(".reveal:not(.revealed)"));
  for (const el of els) {
    if (enabled && io) io.observe(el);
    else el.classList.add("revealed");
  }
}

/** Gives children a stagger index so they follow one another in. */
export function stagger(children, start = 0) {
  [...children].forEach((el, i) => {
    el.setAttribute("data-stagger", "");
    el.style.setProperty("--i", String(Math.min(start + i, 12)));
  });
}
